import { css } from 'styled-system/css';

export const headerStyle = {
	container: css({
		height: 'var(--header-height)',
		bgColor: 'header.containerBg',
	}),
	// header__account 永遠 display:none：裡面有元件是用 portal 渲染到外層，這個容器本身不能被拿掉，只能靠 CSS 藏起來
	headerAccountHidden: css({
		display: 'none',
	}),
	logo: css({
		display: { base: 'none', md: 'flex' },
	}),
	products: css({
		display: 'flex',
		color: 'white',
		alignItems: 'center',
		md: {
			display: 'none',
		},
		'& .icon--dropdown': {
			width: '16px',
			height: '16px',
			ml: '3px',
		},
	}),
	productButton: css({
		pr: 0,
		minHeight: 'unset',
		fontSize: 'md',
		fontWeight: 'normal',
		cursor: 'pointer',
		'& .icon--dropdown': {
			transition: 'transform 200ms ease-in',
		}
	}),
	productButtonText: css({
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis',
		overflow: 'hidden',
		maxWidth: '21vw',
	}),
	productButtonOpen: css({
		'& .icon--dropdown': {
			transform: 'rotate(180deg)'
		}
	}),
	productList: css({
		maxHeight: 0,
		overflow: 'auto',
		position: 'absolute',
		top: 'var(--header-height)',
		left: 0,
		right: 0,
		bgColor: 'var(--other-lv2)',
		boxShadow: '0px 10px 10px 0px rgba(0, 0, 0, 0.19)',
		'& .btn': {
			color: 'black.3',
			borderWidth: '1px',
			borderStyle: 'solid',
			borderColor: 'black.5',
		}
	}),
	productListOpen: css({
		maxHeight: '600px',
		transition: 'max-height 200ms ease-in',
	}),
	productListContainer: css({
		display: 'flex',
		flexWrap: 'wrap',
		maxWidth: '500px',
		p: '6px',
		m: '0 auto',
	}),
	productItem: css({
		position: 'relative',
		width: '33.33333%',
		padding: '3px',
		textAlign: 'center',
		'&:nth-child(3n)': {
			'& .submenu': {
				ml: 'calc(-200% - 12px)',
			},
		},
		'&:nth-child(3n + 2)': {
			'& .submenu': {
				ml: 'calc(-100% - 6px)',
				mr: 'calc(-100% - 6px)',
			},
		},
		'&:nth-child(3n + 1)': {
			'& .submenu': {
				mr: 'calc(-200% - 12px)',
			},
		},
	}),
	productItemButton: css({
		width: '100%',
		position: 'relative',
		'&[data-selected="true"]': {
			'&:not([data-has-submenu="true"])': {
				color: 'brand.500_light',
				border: '1px solid currentColor',
			},
			'&[data-has-submenu="true"]': {
				_before: {
					content: '""',
					position: 'absolute',
					top: '100%',
					left: '-1px',
					right: '-1px',
					height: '12px',
					borderLeftWidth: '1px',
					borderRightWidth: '1px',
					borderColor: 'black.5',
					borderStyle: 'solid',
					bgColor: 'var(--other-lv2)',
					mt: '-4px',
					zIndex: 1,
				},
				'& + .submenu': {
					mt: '6px',
					py: '6px',
					opacity: 1,
					maxHeight: '500px',
					transition: 'all 200ms ease-in',
					visibility: 'visible',
				},
			},
		},
		'& .tag': {
			position: 'absolute',
			left: '-2px',
			top: '-2px',
		}
	}),
	subMenu: css({
		position: 'relative',
		display: 'flex',
		flexWrap: 'wrap',
		gap: '6px',
		opacity: 0,
		maxHeight: 0,
		overflow: 'hidden',
		visibility: 'hidden',
		_before: {
			content: '""',
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			height: '1px',
			backgroundColor: 'black.5',
		},
	}),
	submenuItem: css({
		width: 'calc(100% / 3 - 4px)',
		cursor: 'pointer',
	}),
	submenuImg: css({
		position: 'relative',
		rounded: '6px',
		overflow: 'hidden',
		borderBottomWidth: '1px',
		borderStyle: 'solid',
		borderColor: 'brand.500',
		bgGradient: 'to-b',
		gradientFrom: 'brand.100',
		gradientTo: 'brand.500',
		_before: {
			content: '""',
			position: 'absolute',
			top: '1px',
			left: '1px',
			right: '1px',
			bottom: 0,
			rounded: '4px',
			bgGradient: 'to-r',
			gradientFrom: 'white',
			gradientTo: 'brand.50',
		},
		'& img': {
			width: 'calc(100% - 2px)',
			height: 'calc(100% - 2px)',
			position: 'relative',
			top: '1px',
			left: '1px',
			zIndex: 2,
		}
	}),
	submenuText: css({
		color: 'black.3',
	}),
	newbieInfoButton: css({
		py: '0',
		height: '24px',
		position: 'relative',
	}),
	streamerButton: css({
		color: 'white',
		cursor: 'pointer',
	}),
	tools: css({
		display: 'flex',
		alignItems: 'center',
		'& .icon--dropdown': {
			width: '16px',
			height: '16px',
		},
		'& .btn': {
			minHeight: 'unset',
			fontWeight: 'normal',
		},
	}),
	parlayHelpButton: css({
		color: 'whiteOpacity.100',
		md: {
			display: 'none',
		}
	}),
	parlayButton: css({
		bgColor: 'header.parlayButtonBg',
		px: '6px',
		py: '2px',
		minHeight: 'unset',
		color: 'white',
		height: '20px',
		md: {
			display: 'none',
		}
	}),
	parlayButtonActive: css({
		bgColor: 'secondary.500!',
	}),
	searchButton: css({
		ml: '3px',
	}),
	newbieWithTextButton: css({
		_mdBelow: {
			display: 'none',
		},
		md: {
			position: 'relative',
			display: 'flex',
			alignItems: 'center',
			whiteSpace: 'nowrap',
			bgColor: 'header.parlayButtonBg',
			p: '3px 9px 3px 6px',
			minHeight: 'unset',
			color: 'white',
			width: 'auto',
			rounded: '20px',
			ml: '12px',
		}
	}),
	divider: css({
		display: 'none',
		md: {
			display: 'block',
			width: '1px',
			mx: '12px',
			bgColor: 'whiteOpacity.54',
			height: '26px',
		}
	}),
	userWrap: css({
		display: 'flex',
		md: {
			display: 'none',
		}
	}),
	userButton: css({
		w: '30px',
		h: 'var(--header-height)',
		p: 0,
	}),
	userButtonActive: css({
		'& .icon--dropdown': {
			transition: 'transform 200ms ease-in',
			transform: 'rotate(180deg)',
		},
	}),
	accountInfo: css({
		color: 'whiteOpacity.100',
		mr: 0,
	}),
	currency: css({
		base: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'flex-end',
			width: '100%',
			mr: 0,
			cursor: 'pointer',
			_supportHover: {
				_hover: {
					color: 'var(--p50)',
				},
			}
		}
	}),
	balance: css({
		base: {
			display: 'flex',
			alignItems: 'center',
			fontSize: '12px',
			cursor: 'pointer',
			_supportHover: {
				_hover: {
					color: 'var(--p50)',
				},
			}
		}
	}),
	smIcon: css({
		base: {
			w: '16px',
			h: '16px',
			md: {
				w: '20px',
				h: '20px',
			}
		}
	}),
	eyeIcon: css({
		display: 'none',
		md: {
			display: 'inline-flex',
		}
	}),
	refreshMobile: css({
		base: {
			height: '16px',
			rounded: '16px',
			bgColor: 'blackOpacity.38',
			mr: '3px',
			_rtl: {
				mr: '0',
				ml: '3px',
			},
			md: {
				display: 'none',
			}
		}
	}),
	refreshDesktop: css({
		base: {
			display: 'none',
			md: {
				display: 'inline-flex',
			}
		},
	}),
	balanceButton: css({
		display: 'none',
		md: {
			display: 'flex',
			p: 0,
			mx: '6px',
		},
	}),
	balanceAmount: css(),
	meButton: css({
		display: 'none',
		md: {
			position: 'relative',
			display: 'flex',
			p: 0,
			borderWidth: '2px',
			borderStyle: 'solid',
			borderColor: 'primary.300',
			rounded: '20px',
			cursor: 'pointer',
			'& .festival-avatar-frame': {
				top: '-4px',
				right: '-4px',
				bottom: '-4px',
				left: '-4px',
			}
		},
	}),
	avatar: css({
		color: { base: 'whiteOpacity.100', _dark: 'primary.300' },
		gradientFrom: { base: 'primary.200_50', _dark: 'primary.900' },
		gradientTo: { base: 'primary.200_0', _dark: 'var(--s600)' },
		p: '2px',
		width: '32px',
		height: '32px',
		rounded: '20px',
		borderWidth: '2px',
		borderStyle: 'solid',
		borderColor: 'white.1',
		bgGradient: 'to-br',
	}),
	// for mars mobile home header
	// 已限制 home(lobby)
	homeHeader: css({
		_mdBelow: {
			pr: '9px',
		}
	}),
	// 原本是 container._mars['& .header__container'].pl，套用在所有 mars 頁面的 header__container inner div，不是只有 home/lobby 頁，
	// 不能跟下面只在 isMarsHome 才套用的 marsDesktopHomeHeader 合併，不然非 home 的 mars 頁面手機版會少這個 padding-left
	// (fallback 回 SCSS .header__container 的 padding-left: space(4) = 12px，跟預期的 6px 不一樣)
	containerPadding: css({
		pl: '6px',
	}),
	// 已限制 mars & home(lobby)
	marsDesktopHomeHeader: css({
		_mdBelow: {
			display: 'none',
		}
	}),
	// 這個 div 同時掛了 legacy SCSS 的 .header__container（unlayered，無條件 display:flex + padding-left/right），
	// PandaCSS 輸出全部包在 globals.css 宣告的 @layer 裡（layered），unlayered 一律贏過 layered，不管 specificity/順序，
	// 所以這裡的 display/pr/pl 沒加 !important 完全不會生效，用 Panda 的 !important 語法蓋過去
	marsMobileHomeHeader: css({
		display: 'none!',
		pr: '9px!',
		pl: '6px!',
		_mdBelow: {
			display: 'flex!',
		}
	}),
	backButton: css({
		width: 'auto',
		'& .icon': {
			width: '21px',
			height: '21px',
		}
	}),
	homeLogo: css({
		ml: '9px',
		p: '5px',
		'& img': {
			width: 'auto',
			height: '32px',
		}
	}),
	messageButton: css({
		position: 'relative',
		color: 'brand.500_light',
		'& .badge': {
			position: 'absolute',
			top: '3px',
			right: 0,
			bgColor: 'status.negative',
		}
	}),

	circle: css({
		base: {
			position: 'absolute',
			top: '3px',
			width: '60px',
			height: '60px',
			borderRadius: '50%',
			border: '6px solid rgba(235, 154, 59, 0.10)',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			_ltr: {
				right: '9px',
			},
			_rtl: {
				left: '15px',
			},
			'&::before, &::after': {
				content: '""',
				position: 'absolute',
				inset: '-6px',
				borderRadius: '50%',
				border: '6px solid rgba(235, 154, 59, 0.3)',
				animation: 'ripple-out 1.6s infinite cubic-bezier(0.4, 0, 0.2, 1)'
			},
			'&::after': {
				animationDelay: '0.8s'
			}
		}
	}),
	innerCircle: css({
		base: {
			width: '48px',
			height: '48px',
			borderRadius: '50%',
			border: '6px solid rgba(235, 154, 59, 0.50)',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center'
		}
	}),
	coreCircle: css({
		base: {
			width: '36px',
			height: '36px',
			borderRadius: '50%',
			border: '3px solid #EB9A3B'
		}
	}),
};